import { configurationContainer } from "@/configurationContainer";

export const getProdaBaseUrl = (): string =>
    // Normalize: remove any trailing slashes to ensure consistent joining.
    configurationContainer.PUBLIC_PRODA_URL.replace(/\/+$/, "");
